<div class="sample-order-sidebar" [class.sample-order-modal]="isModal">
  <div class="">
    @if (!isModal) {
      <div class="sample-order-sidebar-header">
        <h2 class="sidebar-title">
          Sample Order Cart
        </h2>
        <button type="button" class="close-btn" (click)="closeEvent.emit(true)">
          <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/white-close-icon.svg'" width="22"
               height="22" alt="Close Icon" loading="lazy">
        </button>
      </div>
    }
    @if (!isModal && !isCheckout) {
      <div class="sample-order-progress">
        <div class="progress">
          <!--        <div class="progress-bar" role="progressbar" [style.width]="progressbarWidth() + '%'"-->
          <!--          [attr.aria-valuenow]="progressbarWidth()" aria-valuemin="0" aria-valuemax="100"></div>-->
          @for (s of steps; track (s + '_step')) {
            <div class="step" [class.active]="s <= progressbarWidth()"></div>
          }
        </div>
        <label>{{ sampleOrders()?.length }}/6</label>
      </div>
    }
    <div class="sample-order-body" [class.step-checkout]="isCheckout">
      @if (isCheckout) {
        <div class="sample-order">
          <form [formGroup]="cartQuoteForm">
            <div>
              <h4 class="title">Information</h4>
              <div>
                <div class="form-group">
                  <label class="form-label">Project Name <span class="req">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter project name"
                         formControlName="project_name">
                  @if (f['project_name'].invalid && f['project_name'].touched &&
                  (f['project_name'].errors?.['required'] || f['project_name'].errors?.['whitespace'] ||
                    f['project_name'].errors?.['apiError'])) {
                    <span class="required-message">Please enter project name</span>
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Project Description</label>
                  <input class="form-control" formControlName="description" placeholder="Enter project description"
                         type="text"/>
                </div>
              </div>

              <h4 class="title">Recipient</h4>
              <div>
                <div class="form-group">
                  <label class="form-label">Name <span class="req">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter recipient name"
                         formControlName="site_contact_name">
                  @if ((f['site_contact_name'].invalid && f['site_contact_name'].touched) ||
                  f['site_contact_name'].errors?.['apiError']) {
                    @if (f['site_contact_name'].errors?.['required']) {
                      <span class="required-message">Please enter recipient name</span>
                    }
                    @if (f['site_contact_name'].errors?.['apiError']) {
                      <span class="required-message">{{ f['site_contact_name'].errors?.['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Mobile Number <span class="req">*</span></label>
                  <input class="form-control" formControlName="site_contact_number" placeholder="Enter mobile number"
                         type="text" maxlength="10" (keydown)="restrictNonNumeric($event)"/>
                  @if ((f['site_contact_number'].invalid && f['site_contact_number'].touched) ||
                  f['site_contact_number'].errors?.['apiError']) {
                    @if (f['site_contact_number'].errors?.['required']) {
                      <span class="required-message">Please enter mobile number</span>
                    }
                    @if (f['site_contact_number'].errors?.['minlength'] &&
                    !f['site_contact_number'].errors?.['mobileNotValid']) {
                      <span class="required-message">Please enter at least 10 characters</span>
                    }
                    @if ((!f['site_contact_number'].errors?.['required'] &&
                      f['site_contact_number'].errors?.['mobileNotValid']) ||
                    f['site_contact_number'].errors?.['maxlength']) {
                      <span class="required-message">Must be a valid australian mobile number</span>
                    }
                    @if (f['site_contact_number'].errors?.['apiError']) {
                      <span class="required-message">{{ f['site_contact_number'].errors?.['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Email <span class="req">*</span></label>
                  <input class="form-control" formControlName="site_contact_email" placeholder="Enter email"
                         type="text"/>
                  @if ((f['site_contact_email'].invalid && f['site_contact_email'].touched) ||
                  f['site_contact_email'].errors?.['apiError']) {
                    @if (f['site_contact_email'].errors?.['required']) {
                      <span class="required-message">Please enter email</span>
                    }
                    @if (f['site_contact_email'].errors?.['email']) {
                      <span class="required-message">Please enter a valid email</span>
                    }
                    @if (f['site_contact_email'].errors?.['apiError']) {
                      <span class="required-message">{{ f['site_contact_email'].errors?.['apiError'] }}</span>
                    }
                  }
                </div>
              </div>

              <h4 class="title">Delivery address</h4>
              <div>
                <div class="form-group">
                  <label class="form-label">Address Line 1 <span class="req">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Address Line 1"
                         formControlName="delivery_address_line_1" ngx-gp-autocomplete #ngxPlaces [options]='options'
                         (onAddressChange)="handleAddressChange($event)">
                  @if ((f['delivery_address_line_1'].invalid && f['delivery_address_line_1'].touched) ||
                  f['delivery_address_line_1'].errors?.['apiError'] ||
                  f['delivery_address_line_1'].errors?.['streetRequired']) {
                    @if (f['delivery_address_line_1'].errors?.['required']) {
                      <span class="required-message">Please enter address line 1</span>
                    }
                    @if (f['delivery_address_line_1'].errors?.['streetRequired']) {
                      <span
                        class="required-message">{{ f['delivery_address_line_1'].errors?.['streetRequired'] }}</span>
                    }
                    @if (f['delivery_address_line_1'].errors?.['apiError']) {
                      <span class="required-message">{{ f['delivery_address_line_1'].errors?.['apiError'] }}</span>
                    }
                    @if (!f['delivery_address_line_1'].errors?.['required'] &&
                    f['delivery_address_line_1'].errors?.['addressNotValid']) {
                      <span class="required-message">PO-box's may not be nominated, as couriers cannot deliver samples to these
                  addresses.</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Address Line 2</label>
                  <input class="form-control" formControlName="delivery_address_line_2"
                         placeholder="Enter address line 2"
                         type="text"/>
                </div>
                <div class="form-group">
                  <label class="form-label">Suburb <span class="req">*</span></label>
                  <input class="form-control" formControlName="delivery_suburb" placeholder="Enter suburb" type="text"/>
                  @if ((f['delivery_suburb'].invalid && f['delivery_suburb'].touched) || (f['delivery_suburb'].errors
                    && f['delivery_suburb'].errors['apiError'])) {
                    @if (f['delivery_suburb'].errors && f['delivery_suburb'].errors['required']) {
                      <span class="required-message">Please enter suburb</span>
                    }
                    @if (f['delivery_suburb'].errors && f['delivery_suburb'].errors['apiError']) {
                      <span class="required-message">{{ f['delivery_suburb'].errors['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">City <span class="req">*</span></label>
                  <input class="form-control" formControlName="delivery_town_city" placeholder="Enter city"
                         type="text"/>
                  @if ((f['delivery_town_city'].invalid && f['delivery_town_city'].touched) ||
                  (f['delivery_town_city'].errors
                    && f['delivery_town_city'].errors['apiError'])) {
                    @if (f['delivery_town_city'].errors && f['delivery_town_city'].errors['required']) {
                      <span class="required-message">Please enter city</span>
                    }
                    @if (f['delivery_town_city'].errors && f['delivery_town_city'].errors['apiError']) {
                      <span class="required-message">{{ f['delivery_town_city'].errors['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">State <span class="req">*</span></label>
                  <input class="form-control" formControlName="delivery_state_region" placeholder="Enter state"
                         type="text"/>
                  @if ((f['delivery_state_region'].invalid && f['delivery_state_region'].touched) ||
                  (f['delivery_state_region'].errors
                    && f['delivery_state_region'].errors['apiError'])) {
                    @if (f['delivery_state_region'].errors && f['delivery_state_region'].errors['required']) {
                      <span class="required-message">Please enter state</span>
                    }
                    @if (f['delivery_state_region'].errors && f['delivery_state_region'].errors['apiError']) {
                      <span class="required-message">{{ f['delivery_state_region'].errors['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Country <span class="req">*</span></label>
                  <input class="form-control" formControlName="delivery_country" placeholder="Enter country"
                         type="text"/>
                  @if ((f['delivery_country'].invalid && f['delivery_country'].touched) || (f['delivery_country'].errors
                    && f['delivery_country'].errors['apiError'])) {
                    @if (f['delivery_country'].errors && f['delivery_country'].errors['required']) {
                      <span class="required-message">Please enter country</span>
                    }
                    @if (f['delivery_country'].errors && f['delivery_country'].errors['apiError']) {
                      <span class="required-message">{{ f['delivery_country'].errors['apiError'] }}</span>
                    }
                  }
                </div>
                <div class="form-group">
                  <label class="form-label">Postal Code <span class="req">*</span></label>
                  <input class="form-control" formControlName="delivery_post_code" placeholder="Enter postcode"
                         type="text"/>
                  @if ((f['delivery_post_code'].invalid && f['delivery_post_code'].touched) ||
                  (f['delivery_post_code'].errors
                    && f['delivery_post_code'].errors['apiError'])) {
                    @if (f['delivery_post_code'].errors && f['delivery_post_code'].errors['required']) {
                      <span class="required-message">Please enter postcode</span>
                    }
                    @if (f['delivery_post_code'].errors && f['delivery_post_code'].errors['apiError']) {
                      <span class="required-message">{{ f['delivery_post_code'].errors['apiError'] }}</span>
                    }
                    @if (f['delivery_post_code'].errors && f['delivery_post_code'].errors['pattern']) {
                      <span class="required-message">Please enter valid postal code</span>
                    }
                  }
                </div>
              </div>
              @if (isCheckout) {
                <h4 class="title">Order Summary</h4>
              }
            </div>
          </form>
        </div>
      }
      <ul class="sample-order-list" [class.sample-checkout-order-list]="isCheckout">
        @for (product of sampleOrders(); track product.id; let idx = $index) {
          <li>
            <div class="sample-order-detail">
              <div class="left-side">
                <img [src]="s3BucketImageURL + '/' + product?.formatHeroImage?.path + IMAGE_SIZE_69_X_69" width="70"
                     height="70" alt="product-img" loading="lazy"
                     [alt]="utilityService.getFileName(product?.formatHeroImage?.path)" appHandleImageError>
                <div class="quote-detail-inner">
                  <label class="product-name">{{ product?.family_name || product?.family?.name }}</label>
                  <span>{{ product.product_collection_name }}{{
                      product.product_category_name ? ' - '
                        + product.product_category_name : ''
                    }}</span>
                </div>
              </div>
              <div class="right-side">
                <label class="price">{{ sampleProductPrice ? sampleProductPrice : 0 | currency }}</label>
                @if (!isCheckout) {
                  <button type="button" class="delete-btn" (click)="removeProduct(product.id)">
                    <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/delete.svg'" width="18"
                         height="20" alt="Sale Icon" loading="lazy">
                  </button>
                }
              </div>
            </div>
          </li>
        } @empty {
          No sample order found
        }
      </ul>
    </div>
  </div>
  <div class="">
    <div class="order-summary">
      @if (!isCheckout) {
        <h4 class="order-summary-title">Order Summary</h4>
      }
      <ul>
        <li>Total Value {{ exclusiveGST }}<span>{{ sampleProductPrice| currency }}</span></li>
        <li>Total Charge {{ exclusiveGST }}<span>{{ 0 | currency }}</span></li>
      </ul>
    </div>
    <div class="sample-order-footer">
      @if (!isCheckout) {
        <button type="button" class="btn btn-secondary" [class.w-100]="!isModal"
                [routerLink]="['/'+ROUTES.ACCOUNT.ROOT+'/'+ROUTES.ACCOUNT.SAMPLES]"
                (click)="isModal ? modalService.dismissAll() : null">
          <span class="btn-secondary-hover"></span>
          <span class="btn-content">View Samples</span>
        </button>
        @if (this.sampleOrders().length > 0) {
          <button type="button" class="btn btn-primary" [class.w-100]="!isModal"
                  (click)="isCheckout = true; scrollToTop()">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Checkout</span>
          </button>
        }
      } @else {
        <button type="button" class="btn btn-primary" (click)="onSubmitQuote()" [disabled]="invalidPostalCode"
                [class.modal-btn]="isModal">
          <span class="btn-primary-hover"></span>
          <span class="btn-content">Confirm</span>
        </button>
      }
    </div>
  </div>
</div>
